import client from "../client";

export interface CliamCommissionRequest {
  hashkey?: string;
}

export interface CliamCommissionResponse {
  message?: string;
}

export default function API(
  request: CliamCommissionRequest
): Promise<CliamCommissionResponse> {
  return client
    .post(`commission/cliam_commission`, request)
    .then((response) => response.data);
}
